import { Layer, Unit } from '@deck.gl/core';
import allPlanesPng from '../../img/all-planes-map-sdf.png';
import allPlanesJson from '../../img/all-planes-map.json';
import { iconSizeScale } from '../IconSize';
import { iconPixelSize, IconType } from '../IconType';
import { ScheduledOrigin } from '../scheduled/ScheduledOrigin';
import { DeckLayerCreator } from './deck-layer-creator';
import { DeckOverlayPlugin } from './deck-overlay-plugin';
import { FlightIconLayerProps, FlightsIconLayer } from './layers/flight/flight-icon-layer';

export class DeckScheduledPlanned extends DeckLayerCreator {
    constructor(plugin: DeckOverlayPlugin) {
        super(plugin);
    }

    createLayers(): Layer[] {
        const layers: Layer[] = [];
        const { visible: scheduledVisible, color: scheduledColor } = this.props?.flights.scheduled || {};
        const { visible: plannedVisible, color: plannedColor } = this.props?.flights.planned || {};
        if (!this.props?.flights.visible || (!scheduledVisible && !plannedVisible)) {
            return [];
        }

        const { showShadow, iconSize } = this.props!.flights.active;
        const version = this.plugin.scheduledUpdater.version;

        const layerProps = {
            visible: true,
            isGlobeView: this.useGlobeView,
            sdfParams: this.plugin.planeSdfParams,
            outlineWidth: 0.05,
            outlineColor: [0, 0, 0, 1] as [number, number, number, number],
            shadowColor: [0, 0, 0, 0.2] as [number, number, number, number],
            showShadow: showShadow,
            billboard: false,
            sizeUnits: 'pixels' as Unit,
            getPosition: (d: ScheduledOrigin) => d.position,
            sizeScale: iconSizeScale(iconSize) * 1.4,
            getSize: iconPixelSize(IconType.largeJet),
            getAngle: 0,
            iconMapping: allPlanesJson,
            iconAtlas: allPlanesPng,
            getIcon: () => IconType.largeJet.toString(),
            getIsHidden: 0,
            pickable: true,
            updateTriggers: {
                data: [version]
            },
            parameters: this.plugin.getRenderingParams({
                cullMode: 'front'
            })
        };
        if (scheduledVisible) {
            const data = this.plugin.scheduledUpdater.getScheduled();
            const scheduledLayer = new FlightsIconLayer<ScheduledOrigin>({
                ...layerProps,
                data,
                id: 'scheduled-flights',
                getColor: scheduledColor,
                getPixelOffset: [-15, 0]
            } as FlightIconLayerProps<ScheduledOrigin>);
            layers.push(scheduledLayer);
        }
        if (plannedVisible) {
            const data = this.plugin.scheduledUpdater.getPlanned();
            const plannedLayer = new FlightsIconLayer<ScheduledOrigin>({
                ...layerProps,
                data,
                id: 'planned-flights',
                getColor: plannedColor,
                getPixelOffset: [15, 0]
            } as FlightIconLayerProps<ScheduledOrigin>);
            layers.push(plannedLayer);
        }

        return layers;
    }
}
